import Button from 'react-bootstrap/Button';
import { useAuth0 } from '@auth0/auth0-react';

const UnauthorizedPage = () => {
  const { logout } = useAuth0();

  return (
    <div className='d-flex justify-content-center align-items-center' style={{ minHeight: '70vh' }}>
      <div className='text-center' style={{ maxWidth: 360 }}>
        <div className='mb-4' style={{ fontSize: '1rem', fontWeight: 500 }}>
          You are logged in but not authorised to use Lexio yet.
        </div>
        <Button
          variant='secondary'
          size='lg'
          style={{
            background: '#7a41ca',
            borderRadius: 10,
            minWidth: 250,
            paddingTop: '0.55rem',
            paddingBottom: '0.55rem',
            fontSize: '0.9rem',
            fontWeight: 500,
            letterSpacing: '0.04em',
          }}
          onClick={() =>
            logout({
              logoutParams: { returnTo: `${window.location.origin}/login` },
            })
          }
        >
          Log out
        </Button>
      </div>
    </div>
  );
};

export default UnauthorizedPage;
